import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { useAuth } from "@/contexts/auth";
import OrganizationSection from "./register/OrganizationSection";
import PersonalInfoSection from "./register/PersonalInfoSection";
import TermsSection from "./register/TermsSection";
import RegisterActions from "./register/RegisterActions";

const RegisterForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();
  const { signUp } = useAuth();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!organizationName.trim()) {
      toast({
        title: "Erreur",
        description: "Veuillez entrer un nom d'organisation.",
        variant: "destructive",
      });
      return;
    }
    
    if (!phone.trim()) {
      toast({
        title: "Erreur",
        description: "Veuillez entrer un numéro de téléphone.",
        variant: "destructive",
      });
      return;
    }

    setIsLoading(true);
    
    try {
      const registrationData = {
        full_name: name,
        phone_number: phone,
        organization: organizationName,
        plan: "enterprise"
      };
      
      console.log("Début de l'inscription:", {
        name,
        email,
        phone,
        organization: organizationName,
        plan: "enterprise"
      });
      
      const { data, error } = await signUp(email, password, registrationData);
      
      if (error) {
        throw error;
      }
      
      console.log("Inscription réussie:", data);
      console.log("Métadonnées utilisateur:", data?.user?.user_metadata);
      
      toast({
        title: "Compte créé avec succès",
        description: "Un email de confirmation a été envoyé à votre adresse. Veuillez vérifier votre boîte de réception et confirmer votre compte avant de vous connecter.",
        variant: "default",
        duration: 8000,
      });
      
      navigate("/login", { 
        state: { 
          needsConfirmation: true,
          email: email 
        } 
      });
    } catch (error: any) {
      console.error("Erreur d'inscription:", error);
      toast({
        title: "Erreur d'inscription",
        description: error.message || "Un problème est survenu lors de la création de votre compte.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-8 space-y-6">
      <form className="space-y-6" onSubmit={handleRegister}>
        <OrganizationSection 
          organizationName={organizationName} 
          setOrganizationName={setOrganizationName} 
        />

        <PersonalInfoSection 
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          phone={phone}
          setPhone={setPhone}
        />

        <TermsSection />

        <RegisterActions isLoading={isLoading} />
      </form>
    </div>
  );
};

export default RegisterForm;
